import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// LegalLayout — shared shell for Impressum / Datenschutz / AGB
export default function LegalLayout({ title, kicker, children }) {
  return (
    <div className="pt-28 pb-20 bg-[#0A0A0B] min-h-screen text-white" data-testid="legal-page">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <Link to="/" className="text-sm text-zinc-500 hover:text-white inline-flex items-center gap-1 mb-8" data-testid="legal-back-home">
          <ArrowLeft className="w-4 h-4" /> Zur Startseite
        </Link>
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#FF2D40] font-bold">{kicker}</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-3 leading-[1.05]">{title}</h1>
        <div className="mt-10 space-y-6 legal-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export function Placeholder({ children }) {
  return (
    <mark className="inline px-2 py-0.5 rounded bg-[#DC1928]/10 border border-[#DC1928]/25 text-[#FF8E97] text-xs font-mono whitespace-normal">
      ⚠ {children}
    </mark>
  );
}
